import type { SVGProps } from 'react';

export function SnakeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 6a3.6 3.6 0 0 1 3.6-3.6h1.44a3.36 3.36 0 0 1 3.36 3.36V16.5a5.1 5.1 0 0 1-10.2 0v-3a1.5 1.5 0 1 0-3 0v6.3a1.8 1.8 0 0 1-3.6 0v-6.3a5.1 5.1 0 0 1 10.2 0v3a1.5 1.5 0 1 0 3 0V9.6h-1.2A3.6 3.6 0 0 1 12 6m5.4-.3c0-.499-.401-.9-.9-.9s-.9.401-.9.9.401.9.9.9.9-.401.9-.9" />
    </svg>
  );
}
